const { JOURNEY_TYPE } = require("../../constants");

const getIsVACJourneySelected = journey => journey === JOURNEY_TYPE.VAC;

module.exports = { getIsVACJourneySelected };
